var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pwdResetSend"}},[_c('div',{staticClass:"wrapper"},[_c('PwdResetSendForm')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }